import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { axiosBeelineRequest } from '@beef/utils';
import { devApiConstants, isDev } from "../../config";
import { refreshTokenRequest } from "./captcha";
import { endpoints } from "../endpoints";
import { instance } from "../config";
import { getEndpoints } from "../utils";
export var authorize = function authorize(login, password) {
  return instance.get(endpoints.UAT.auth, {
    params: {
      client_id: devApiConstants.UAT_AUTH_CLIENTID,
      login: login,
      password: password
    }
  });
};
export var fetchTokenInfo = function fetchTokenInfo() {
  return axiosBeelineRequest({
    method: 'post',
    baseURL: isDev ? getEndpoints().http : undefined,
    url: endpoints.tokenAuthZone.gettoken,
    withCredentials: !isDev
  });
};
export var fetchAuthToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _data$View;
    var flag,
      _yield$refreshTokenRe,
      _data,
      data,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          flag = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
          if (flag) {
            _context.next = 7;
            break;
          }
          _context.next = 4;
          return refreshTokenRequest();
        case 4:
          _yield$refreshTokenRe = _context.sent;
          _data = _yield$refreshTokenRe.data;
          return _context.abrupt("return", _data === null || _data === void 0 ? void 0 : _data.accessToken);
        case 7:
          _context.next = 9;
          return fetchTokenInfo();
        case 9:
          data = _context.sent;
          return _context.abrupt("return", data === null || data === void 0 || (_data$View = data.View) === null || _data$View === void 0 ? void 0 : _data$View.token);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchAuthToken() {
    return _ref.apply(this, arguments);
  };
}();